import React, { useState } from "react";
import "./SitePlanSideBar.scss";
import { useDispatch, useSelector } from "react-redux";
import {
    activateAllLotsOfType,
    addSiteplanActiveFloorplanFilterID,
    clearAllFloorplanFilters,
    deactivateAllLotsOfType,
    removeSiteplanActiveFloorplanFilterID,
    updateSiteplanActiveFloorplanID,
    updateSiteplanLotActiveIndex,
    updateSiteplanLotOutlines,
} from "../../redux/actions/siteplanActions";
import SquareFootIcon from "../SquareFootIcon/SquareFootIcon";
import {
    updateActiveElevation,
    updateActiveFloorplan,
    updateActiveFloorplanViaID,
} from "../../redux/actions/floorplanActions";
import { useHistory } from "react-router-dom";
import { useScrollBoost } from "react-scrollbooster";
import Check from "./check";

function InteractiveMenuButton(props) {
    var classes = "InteractiveMenuButton";
    if (props.floorplan) classes += " floorplan";
    if (!props.open) classes += " closed";

    function togglePanel() {
        if (props.floorplan) {
            //get rid of the floorplan selection
            props.closeFloorplanDisplay();
        } else {
            if (props.open) {
                props.closePanel();
            } else {
                props.openPanel();
            }
        }
    }

    return (
        <button className={classes} onClick={() => togglePanel()}>
            <span />
            <span />
        </button>
    );
}

function SiteplanSideBar(props) {
    var openContainerclasses = "lots-open-container";
    if (props.panelOpen) openContainerclasses += " open";
    var siteplanActiveID = useSelector(
        (state) => state.siteplan.activeFlooplanID
    );
    var activeLotIndex = useSelector((state) => state.siteplan.activeLotIndex);
    var lots = useSelector((state) => state.siteplan.lots);
    var dispatch = useDispatch();
    var icons = useSelector((state) => state.content);
    var activeFloorplanFilterIndexes = useSelector(
        (state) => state.siteplan.activeFloorplanFilterIndexes
    );
    var displayedFilteredFloorplans = useSelector(
        (state) => state.siteplan.displayedFilteredFloorplans
    );
    var history = useHistory();

    /*
    var [viewport] = useScrollBoost({
        direction: 'all',
        friction: 0.05,
        scrollMode: 'native',
        onClick: (state, event) => {
            //console.log(state);
            console.log(state);
            if (state.isDragging && state.isMoving) {
                //event.preventDefault();
                //event.stopPropagation();
            }
        },
        touchStart: (state, event) => {
            console.log(state);
            console.log(event);
        }
    });
    */

    function floorplanIndexViaFloorplanID(ID) {
        if (typeof props.floorplans !== "undefined") {
            for (var i = 0; i < props.floorplans.length; i++) {
                //please dont screw me later
                if (props.floorplans[i].ID == ID) return i;
            }
        }

        return -1;
    }

    function resetSideBarFilters() {
        dispatch(clearAllFloorplanFilters());
        dispatch(updateSiteplanLotOutlines());
    }

    function lotColourClsViaTypeKey(key) {
        var cls = "blue";

        if (key == "36'") {
            cls = "green";
        } else if (key == "40'") {
            cls = "orange";
        }

        return cls;
    }

    function sideBarClasses() {
        var classes = "side-bar";

        if (displayedFilteredFloorplans.length != 0) {
            classes += " floorplan";
        }

        return classes;
    }

    function titleBarClasses() {
        var classes = "title-bar";

        if (activeLotIndex != -1) {
            if (lots[activeLotIndex].lot_data.path_data.type == "30'") {
                classes += " blue";
            }
            if (lots[activeLotIndex].lot_data.path_data.type == "36'") {
                classes += " green";
            }
            if (lots[activeLotIndex].lot_data.path_data.type == "40'") {
                classes += " orange";
            }
        }

        return classes;
    }

    function displayProperTitleBarText() {
        var txt = "Select lots";

        if (activeLotIndex != -1) txt = "Available Models";

        return txt;
    }

    function lotsInfoClasses() {
        var classes = "lots-info-container";

        if (activeLotIndex != null) classes += " floorplan";

        return classes;
    }

    function elevationsContainerClasses() {
        var classes = "elevations-container";

        if (activeLotIndex != -1) {
            if (lots[activeLotIndex].lot_data.path_data.type == "36'") {
                classes += " green";
            }
            if (lots[activeLotIndex].lot_data.path_data.type == "40'") {
                classes += " orange";
            }
        }

        return classes;
    }

    function floorplanInFilters(ID) {
        for (var i = 0; i < activeFloorplanFilterIndexes.length; i++) {
            if (activeFloorplanFilterIndexes[i] == ID) return true;
        }

        return false;
    }

    function closeFloorplanPanel() {
        dispatch(updateSiteplanLotActiveIndex(-1));
        dispatch(updateSiteplanLotOutlines());
    }

    function lotButtonClicked(ID) {
        //we need to give the floorplan index because we're not going to be connected to all of that filtering
        //dispatch(updateSiteplanActiveFloorplanID(ID));
        //dispatch(updateSiteplanLotOutlines());

        //check if this filter is on already
        if (floorplanInFilters(ID))
            dispatch(removeSiteplanActiveFloorplanFilterID(ID));
        else dispatch(addSiteplanActiveFloorplanFilterID(ID));

        dispatch(updateSiteplanLotOutlines());
    }

    function allLotsOfTypeActive(lots) {
        if (lots.length == 0) return false;

        for (var i = 0; i < lots.length; i++) {
            if (!floorplanInFilters(lots[i].ID)) return false;
        }

        return true;
    }

    function allLotsButtonClicked(lots) {
        if (allLotsOfTypeActive(lots)) {
            dispatch(deactivateAllLotsOfType(lots));
        } else {
            dispatch(activateAllLotsOfType(lots));
        }

        dispatch(updateSiteplanLotOutlines());
    }

    function navigateToFloorplanPageWithElevationAndFPSelected(fp, elevation) {
        //update the ativefloorplan and elevation then go to the page
        //fpINdex and elevationindex both numbers not the floorplan postid
        //dispatch(updateActiveFloorplan(fp));
        dispatch(updateActiveFloorplanViaID(fp));
        dispatch(updateActiveElevation(elevation));
        history.push("/floorplans/details");
    }

    if ("floorplans" in icons.pages) {
        var icons = icons.pages.floorplans.floorplan_product_icons;

        var index = -1;

        if (siteplanActiveID != -1)
            index = floorplanIndexViaFloorplanID(siteplanActiveID);

        var activeFloorplan = null;

        if (index != -1) activeFloorplan = props.floorplans[index];

        //console.log(displayedFilteredFloorplans)

        return (
            <div className={sideBarClasses()}>
                <div className="lots-info-container">
                    <div className={titleBarClasses()}>
                        <div className="lots-title">
                            {displayProperTitleBarText()}
                        </div>
                        <InteractiveMenuButton
                            open={props.panelOpen}
                            closePanel={props.closePanel}
                            openPanel={props.openPanel}
                            floorplan={displayedFilteredFloorplans.length > 0}
                            closeFloorplanDisplay={() => closeFloorplanPanel()}
                        />
                    </div>
                    <div className={openContainerclasses}>
                        <div className="contaianer-viewport">
                            <div className="open-container-wrapper">
                                {displayedFilteredFloorplans.length > 0 &&
                                    displayedFilteredFloorplans.map(
                                        (activeFloorplan) => (
                                            <div className="floorplan-info-container">
                                                <div className="title">
                                                    {activeFloorplan.post_title}
                                                </div>
                                                <div
                                                    className={elevationsContainerClasses()}
                                                >
                                                    {activeFloorplan.elevations.map(
                                                        (elv, ekey) => (
                                                            <button
                                                                className="elevation"
                                                                onClick={() =>
                                                                    navigateToFloorplanPageWithElevationAndFPSelected(
                                                                        activeFloorplan
                                                                            .floorplan
                                                                            .ID,
                                                                        elv
                                                                    )
                                                                }
                                                            >
                                                                <div className="image-container">
                                                                    <img
                                                                        className="elv-image"
                                                                        src={
                                                                            activeFloorplan
                                                                                .floorplan
                                                                                .elevation[
                                                                                elv
                                                                            ]
                                                                                .elevation_image
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className="stats-container">
                                                                    <div className="stats-title">
                                                                        {
                                                                            activeFloorplan
                                                                                .floorplan
                                                                                .post_title
                                                                        }{" "}
                                                                        {
                                                                            activeFloorplan
                                                                                .floorplan
                                                                                .elevation[
                                                                                elv
                                                                            ]
                                                                                .elevation_name
                                                                        }
                                                                    </div>
                                                                    <div className="stats">
                                                                        {Object.keys(
                                                                            activeFloorplan
                                                                                .floorplan
                                                                                .elevation[
                                                                                elv
                                                                            ]
                                                                                .stats
                                                                        ).map(
                                                                            (
                                                                                skey,
                                                                                index
                                                                            ) => (
                                                                                <div
                                                                                    className={`stat ${skey}`}
                                                                                    key={
                                                                                        index
                                                                                    }
                                                                                >
                                                                                    <div className="icon-container">
                                                                                        <img
                                                                                            src={
                                                                                                icons[
                                                                                                    skey
                                                                                                ]
                                                                                            }
                                                                                            className={`icon ${skey}`}
                                                                                        />
                                                                                    </div>
                                                                                    <span className="label">
                                                                                        {
                                                                                            activeFloorplan
                                                                                                .floorplan
                                                                                                .elevation[
                                                                                                elv
                                                                                            ]
                                                                                                .stats[
                                                                                                skey
                                                                                            ]
                                                                                        }
                                                                                    </span>
                                                                                </div>
                                                                            )
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </button>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    )}
                                {displayedFilteredFloorplans.length == 0 && (
                                    <div className="lots-container">
                                        {Object.keys(props.lotsByType).map(
                                            (key, index) => (
                                                <div className="lot-data-container">
                                                    <div className="title">
                                                        {key} Lots
                                                    </div>
                                                    <div
                                                        className={`lot-colour-container ${lotColourClsViaTypeKey(key)}`}
                                                    >
                                                        <button
                                                            className={`all-radio${allLotsOfTypeActive(props.floorplansByType[key]) ? " active" : ""}`}
                                                            onClick={() =>
                                                                allLotsButtonClicked(
                                                                    props
                                                                        .floorplansByType[
                                                                        key
                                                                    ],
                                                                    index
                                                                )
                                                            }
                                                        >
                                                            <div className="square">
                                                                <Check />
                                                            </div>
                                                            <span className="label">
                                                                Select All {key}{" "}
                                                                Lots
                                                            </span>
                                                        </button>
                                                        <div className="lot-options-container">
                                                            {props.floorplansByType[
                                                                key
                                                            ].map(
                                                                (
                                                                    floorplan,
                                                                    fpkey
                                                                ) => (
                                                                    <button
                                                                        className={`lot-button${floorplanInFilters(floorplan.ID) ? " active" : ""}`}
                                                                        key={
                                                                            fpkey
                                                                        }
                                                                        onClick={() =>
                                                                            lotButtonClicked(
                                                                                floorplan.ID
                                                                            )
                                                                        }
                                                                    >
                                                                        {
                                                                            floorplan.post_title
                                                                        }
                                                                    </button>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                        <button
                                            className="reset-filter-button"
                                            onClick={() =>
                                                resetSideBarFilters()
                                            }
                                        >
                                            Reset Filters
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={openContainerclasses + " mobile"}>
                        {displayedFilteredFloorplans.length > 0 &&
                            displayedFilteredFloorplans.map(
                                (activeFloorplan) => (
                                    <div className="floorplan-info-container">
                                        <div className="title">
                                            {activeFloorplan.post_title}
                                        </div>
                                        <div
                                            className={elevationsContainerClasses()}
                                        >
                                            {activeFloorplan.elevations.map(
                                                (elv, ekey) => (
                                                    <button
                                                        className="elevation"
                                                        onClick={() =>
                                                            navigateToFloorplanPageWithElevationAndFPSelected(
                                                                activeFloorplan
                                                                    .floorplan
                                                                    .ID,
                                                                elv
                                                            )
                                                        }
                                                    >
                                                        <div className="image-container">
                                                            <img
                                                                className="elv-image"
                                                                src={
                                                                    activeFloorplan
                                                                        .floorplan
                                                                        .elevation[
                                                                        elv
                                                                    ]
                                                                        .elevation_image
                                                                }
                                                            />
                                                        </div>
                                                        <div className="stats-container">
                                                            <div className="stats-title">
                                                                {
                                                                    activeFloorplan
                                                                        .floorplan
                                                                        .post_title
                                                                }{" "}
                                                                {
                                                                    activeFloorplan
                                                                        .floorplan
                                                                        .elevation[
                                                                        elv
                                                                    ]
                                                                        .elevation_name
                                                                }
                                                            </div>
                                                            <div className="stats">
                                                                {Object.keys(
                                                                    activeFloorplan
                                                                        .floorplan
                                                                        .elevation[
                                                                        elv
                                                                    ].stats
                                                                ).map(
                                                                    (
                                                                        skey,
                                                                        index
                                                                    ) => (
                                                                        <div
                                                                            className={`stat ${skey}`}
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <div className="icon-container">
                                                                                <img
                                                                                    src={
                                                                                        icons[
                                                                                            skey
                                                                                        ]
                                                                                    }
                                                                                    className={`icon ${skey}`}
                                                                                />
                                                                            </div>
                                                                            <span className="label">
                                                                                {
                                                                                    activeFloorplan
                                                                                        .floorplan
                                                                                        .elevation[
                                                                                        elv
                                                                                    ]
                                                                                        .stats[
                                                                                        skey
                                                                                    ]
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                    )
                                                                )}
                                                            </div>
                                                        </div>
                                                    </button>
                                                )
                                            )}
                                        </div>
                                    </div>
                                )
                            )}
                        {displayedFilteredFloorplans.length == 0 && (
                            <div className="lots-container">
                                {Object.keys(props.lotsByType).map(
                                    (key, index) => (
                                        <div className="lot-data-container">
                                            <div className="title">
                                                {key} Lots
                                            </div>
                                            <div
                                                className={`lot-colour-container ${lotColourClsViaTypeKey(key)}`}
                                            >
                                                <button
                                                    className={`all-radio${allLotsOfTypeActive(props.floorplansByType[key]) ? " active" : ""}`}
                                                    onClick={() =>
                                                        allLotsButtonClicked(
                                                            props
                                                                .floorplansByType[
                                                                key
                                                            ],
                                                            index
                                                        )
                                                    }
                                                >
                                                    <div className="square">
                                                        <Check />
                                                    </div>
                                                    <span className="label">
                                                        Select All {key} Lots
                                                    </span>
                                                </button>
                                                <div className="lot-options-container">
                                                    {props.floorplansByType[
                                                        key
                                                    ].map(
                                                        (floorplan, fpkey) => (
                                                            <button
                                                                className={`lot-button${floorplanInFilters(floorplan.ID) ? " active" : ""}`}
                                                                key={fpkey}
                                                                onClick={() =>
                                                                    lotButtonClicked(
                                                                        floorplan.ID
                                                                    )
                                                                }
                                                            >
                                                                {
                                                                    floorplan.post_title
                                                                }
                                                            </button>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )}
                                <button
                                    className="reset-filter-button"
                                    onClick={() => resetSideBarFilters()}
                                >
                                    Reset Filters
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    } else return <div></div>;
}

export default SiteplanSideBar;

